
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.704 12.605a.782.782 0 00.578-.227.782.782 0 00.227-.577V.838a.838.838 0 00-.23-.59A.767.767 0 007.69 0a.92.92 0 00-.457.113c-.135.076-.292.2-.471.375L3.718 3.354a.247.247 0 01-.172.062H1.491c-.485 0-.855.132-1.11.395C.127 4.074 0 4.465 0 4.983v2.66c0 .517.127.907.381 1.168.255.261.625.392 1.11.392h2.055c.07 0 .126.02.172.062l3.045 2.893c.165.156.32.27.467.34.147.071.305.107.474.107zm6.495-1.35a.585.585 0 00.365-.245 7.372 7.372 0 001.058-2.172A8.61 8.61 0 0016 6.296c0-.876-.125-1.726-.375-2.55a7.018 7.018 0 00-1.061-2.165.578.578 0 00-.365-.251.528.528 0 00-.419.093.482.482 0 00-.227.36.628.628 0 00.13.45c.386.546.685 1.17.898 1.874a7.51 7.51 0 01.32 2.189 7.34 7.34 0 01-.327 2.182 6.948 6.948 0 01-.89 1.88.653.653 0 00-.127.446.49.49 0 00.223.364.543.543 0 00.42.086zm-2.763-1.856a.55.55 0 00.365-.244c.27-.362.482-.793.635-1.292.154-.5.23-1.022.23-1.567 0-.546-.076-1.068-.23-1.567-.153-.5-.365-.93-.635-1.293a.564.564 0 00-.365-.247.509.509 0 00-.398.082.566.566 0 00-.251.392c-.02.156.024.31.134.46.206.28.364.61.474.99.11.38.165.775.165 1.183 0 .407-.055.8-.165 1.178-.11.378-.268.71-.474.993a.628.628 0 00-.134.46c.02.157.104.285.25.386a.52.52 0 00.4.086z","fill":"#fff"}})])
          )
        }
      }
    